export default "__VITE_ASSET__Dfh13ajk__"